<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <div v-for="(bread, key) in breadcrumbs" :key="key">
              <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumbs.length">
                <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
              </li>
              <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
            </div>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:250px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select_category form-select-sm border-primary w-200px me-5">
              <option :value="'all'" selected>{{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" :value="'ecommerce'">{{ $t('dashboard.ecommerce') }}</option>
              <option v-for="filter in shops" :value="filter.id" :key="filter.id">{{ filter.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                  <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div v-show="isReady" id="kt_content_container" class="container-xxl">

        <!-- KPI Cards -->
        <div class="row g-5 mb-8">

          <!-- Catégories avec ventes -->
          <div class="col-12 col-sm-6 col-lg-6">
            <div class="kpi-card h-100">
              <div class="kpi-icon-box" style="background:rgba(80,205,137,0.1)">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#50CD89"/>
                  <path d="M7 12L10 15L17 9" stroke="#50CD89" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="flex-grow-1">
                <div class="kpi-big-number">{{ categoryStats.categories_with_sales_count ?? 0 }} <small class="fs-5 fw-normal text-muted">/ {{ categoryStats.total_categories ?? 0 }}</small></div>
                <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.category_sales') }}</div>
              </div>
            </div>
          </div>

          <!-- Chiffre d'affaires -->
          <div class="col-12 col-sm-6 col-lg-6">
            <div class="kpi-card h-100">
              <div class="kpi-icon-box" style="background:rgba(114,57,234,0.1)">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#7239EA"/>
                  <path d="M14.5 7H9.5C8.67157 7 8 7.67157 8 8.5C8 9.32843 8.67157 10 9.5 10H14.5C15.3284 10 16 9.32843 16 8.5C16 7.67157 15.3284 7 14.5 7Z" fill="#7239EA"/>
                  <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14H9.5C8.67157 14 8 13.3284 8 12.5C8 11.6716 8.67157 11 9.5 11H14.5C15.3284 11 16 11.6716 16 12.5C16 13.3284 15.3284 14 14.5 14H13V17Z" fill="#7239EA"/>
                </svg>
              </div>
              <div class="flex-grow-1">
                <div class="kpi-big-number">
                  {{ turnover }} <small class="fs-5 fw-normal text-muted">{{ currency }}</small>
                </div>
                <div class="text-gray-500 fw-semibold fs-6">{{ $t('dashboard.turnover') }}</div>
              </div>
            </div>
          </div>

        </div>

        <!-- KPI Cards : Packs -->
        <div class="row g-5 mb-8">

          <!-- CA Packs -->
          <div class="col-12 col-sm-6 col-lg-6">
            <div class="kpi-card h-100">
              <div class="kpi-icon-box" style="background:rgba(var(--kt-primary-rgb, 11, 61, 135),0.1)">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 8V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V8H21Z" fill="#0b3d87"/>
                  <path d="M20 4H4C3.4 4 3 4.4 3 5V7C3 7.6 3.4 8 4 8H20C20.6 8 21 7.6 21 7V5C21 4.4 20.6 4 20 4Z" fill="#0b3d87"/>
                </svg>
              </div>
              <div class="flex-grow-1">
                <div class="kpi-big-number">
                  {{ $formatLocalAmount(categoryStats.packs_stats?.pack_ca ?? 0) }} <small class="fs-5 fw-normal text-muted">{{ currency }}</small>
                </div>
                <div class="text-gray-500 fw-semibold fs-6">{{ $t('statistics.packs_turnover') }} ({{ categoryStats.packs_stats?.pack_share ?? 0 }}%)</div>
              </div>
            </div>
          </div>

          <!-- CA Produits simples -->
          <div class="col-12 col-sm-6 col-lg-6">
            <div class="kpi-card h-100">
              <div class="kpi-icon-box" style="background:rgba(0,158,247,0.1)">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="#009EF7"/>
                  <path d="M7 12L10 15L17 9" stroke="#009EF7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="flex-grow-1">
                <div class="kpi-big-number">
                  {{ $formatLocalAmount(categoryStats.packs_stats?.product_ca ?? 0) }} <small class="fs-5 fw-normal text-muted">{{ currency }}</small>
                </div>
                <div class="text-gray-500 fw-semibold fs-6">{{ $t('statistics.products_turnover') }} ({{ categoryStats.packs_stats?.product_share ?? 0 }}%)</div>
              </div>
            </div>
          </div>

        </div>

        <!-- Graphe : CA par produit (top 10) -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(255,199,0,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M12 2L20.6603 7V17L12 22L3.33975 17V7L12 2Z" fill="#FFC700"/>
                      <path d="M12 2L20.6603 7L12 12L3.33975 7L12 2Z" fill="#FFC700"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.sale_by_product') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Chiffre d'affaires par produit (top 10)</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!categoryStats?.sales_by_product?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : cards -->
                  <div v-if="isMobile" class="row g-3">
                    <div v-for="item in categoryStats.sales_by_product" :key="item.product_name" class="col-6">
                      <div class="cat-stat-card">
                        <div class="cat-stat-name">{{ item.product_name }}</div>
                        <div class="cat-stat-value" style="color:#FFC700">
                          {{ $formatLocalAmount(item.total_sales) }}
                          <small class="cat-stat-currency">{{ currency }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : graphe -->
                  <div v-else id="sales-by-product" style="height:380px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Graphe : Ventes par catégorie (CA + quantité, combiné) -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(0,158,247,0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M2 13H10V21H2V13ZM14 5H22V21H14V5Z" fill="#009EF7"/>
                      <path d="M2 3H10V12H2V3ZM14 3H22V4H14V3Z" fill="#009EF7"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.sale_by_category') }}</div>
                    <div class="fs-7 text-muted fw-semibold">Chiffre d'affaires et quantités vendues par catégorie (top 10)</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!categoryStats?.sales_by_category?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : cards (CA + quantité) -->
                  <div v-if="isMobile" class="row g-3">
                    <div v-for="item in categoryStats.sales_by_category" :key="item.category_name" class="col-6">
                      <div class="cat-stat-card">
                        <div class="cat-stat-name">{{ item.category_name }}</div>
                        <div class="cat-stat-value" style="color:#3F51B5">
                          {{ $formatLocalAmount(item.total_sales) }}
                          <small class="cat-stat-currency">{{ currency }}</small>
                        </div>
                        <div class="cat-stat-value" style="color:#0b3d87; font-size:0.85rem;">
                          {{ categoryQuantityFor(item.category_name) }}
                          <small class="cat-stat-currency">{{ $t('statistics.quantity_sold') }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : graphe combiné (CA en barres, quantité en ligne) -->
                  <div v-else id="category-combo-chart" style="height:380px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Tableau : Pack le plus vendu -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-5">
                <h3 class="card-title d-flex align-items-center">
                  <div class="section-icon me-3" style="background:rgba(var(--kt-primary-rgb, 11, 61, 135),0.1)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M21 8V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V8H21Z" fill="#0b3d87"/>
                      <path d="M20 4H4C3.4 4 3 4.4 3 5V7C3 7.6 3.4 8 4 8H20C20.6 8 21 7.6 21 7V5C21 4.4 20.6 4 20 4Z" fill="#0b3d87"/>
                    </svg>
                  </div>
                  <div>
                    <div class="fw-bolder fs-5 text-gray-800">{{ $t('statistics.top_packs') }}</div>
                  </div>
                </h3>
              </div>
              <div class="card-body pt-3">
                <div v-if="!categoryStats?.top_packs?.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-80px mb-4"/>
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed align-middle gy-3">
                    <thead>
                      <tr class="text-muted fw-bold fs-7 text-uppercase">
                        <th>{{ $t('statistics.pack') }}</th>
                        <th class="text-end">{{ $t('statistics.quantity_sold') }}</th>
                        <th class="text-end">{{ $t('dashboard.turnover') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in categoryStats.top_packs" :key="item.pack_name">
                        <td class="fw-semibold">{{ item.pack_name }}</td>
                        <td class="text-end">{{ item.quantity }}</td>
                        <td class="text-end fw-bold" style="color:#0b3d87">{{ $formatLocalAmount(item.ca) }} {{ currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Loader -->
      <div class="container-xxl" v-show="!isReady">
        <Loader text="Loading..." />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  components: { Loader },
  data() {
    return {
      title: "navigation.statistique",
      breadcrumbs: [
        { name: 'navigation.statistique_category', path: '/admin' },
      ],
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      contacts: 0,
      products: 0,
      turnover: 0,
      turnoverTotal: 0,
      currency: '',
      categoryStats: {},
      isReady: false,
      iso: '',
      categoryComboChart: null,
      salesByProduct: null,
      isMobile: window.innerWidth <= 767,
    }
  },

  watch: {
    shop_selected: async function (value) {
      if (value) {
        this.isReady = false
        await this.drawCharts()
      }
    },
    '$i18n.locale': function (value) {
      if (value) {
        this.$nextTick(() => this.initDateRange())
      }
    }
  },

  async mounted() {
    this.isReady = false
    window.addEventListener('resize', this._onResize = () => {
      this.isMobile = window.innerWidth <= 767
    })
    KTApp.initSelect2()
    // loadUserShops() doit résoudre AVANT initSelect() : select2 fige la
    // liste d'options au moment de son init, et les <option v-for="filter
    // in shops"> n'existent pas encore tant que shops est vide — cliquer
    // sur la boutique n'importe quoi (select2 ne connaît pas cette option),
    // le filtre retombait silencieusement sur 'all'.
    await this.loadUserShops()
    if (this.shops && this.shops.length) {
      this.shop_selected = 'all'
    }
    await this.initSelect()
    await this.initDateRange()
    let response = await this.getCurrency()
    this.iso = response?.data?.currency_symbol
    this.currency = response.data?.currency_symbol ?? response.data?.symbol_native
  },

  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },

  methods: {
    ...mapActions('shop', ['getCurrency']),

    async loadUserShops() {
      await axios.get(`/dashboard/shops`)
        .then((response) => { this.shops = response.data.shops })
        .catch((error) => { console.log(error) })
    },

    async loadCategoryStats() {
      if (!this.shop_selected || !this.startDate || !this.endDate) return
      await axios.get(`/dashboard/statistics/category?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
        .then((response) => { this.categoryStats = response.data })
        .catch((error) => { console.log(error) })
    },

    async initSelect() {
      // select2 recopie TOUJOURS les classes du <select> d'origine sur le
      // <span> qu'il génère pour l'affichage (y compris une classe dédiée
      // comme "kt_select_category") — un sélecteur par classe seule matche
      // donc les deux éléments. Il faut qualifier par balise ("select.xxx")
      // pour n'attraper que le vrai <select>, sinon select2 s'initialise
      // aussi sur le <span> et la sélection ne se committe jamais (l'option
      // cliquée ne met jamais à jour le <select>, qui retombe sur 'all').
      let kt_select = $('body select.kt_select_category')
      kt_select.select2()
      kt_select.change((e) => {
        if (e.target.name === 'filter') {
          this.shop_selected = e.target.value
        }
      })
    },

    buildChartOptions({ categories, values, seriesName, color }) {
      const borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const gray500 = KTUtil.getCssVariableValue('--bs-gray-500')
      const gray700 = KTUtil.getCssVariableValue('--bs-gray-700')

      if (this.isMobile) {
        const height = Math.max(320, categories.length * 44)
        return {
          series: [{ name: seriesName, data: values }],
          chart: { fontFamily: 'inherit', type: 'bar', height, toolbar: { show: false } },
          plotOptions: {
            bar: { horizontal: true, barHeight: '55%', borderRadius: 4, dataLabels: { position: 'right' } }
          },
          dataLabels: {
            enabled: true,
            offsetX: 6,
            style: { fontSize: '11px', fontWeight: 600, colors: [gray700] }
          },
          legend: { show: false },
          stroke: { show: false },
          xaxis: {
            categories,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: { style: { colors: gray500, fontSize: '11px' } }
          },
          yaxis: {
            labels: {
              style: { colors: gray700, fontSize: '12px', fontWeight: 600 },
              maxWidth: 140,
            }
          },
          fill: { opacity: 1 },
          tooltip: { style: { fontSize: '12px' } },
          colors: [color],
          grid: { borderColor, strokeDashArray: 4, xaxis: { lines: { show: true } }, yaxis: { lines: { show: false } } }
        }
      }

      return {
        series: [{ name: seriesName, data: values }],
        chart: { fontFamily: 'inherit', type: 'bar', height: 380, toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: false, columnWidth: '40%', borderRadius: 5, dataLabels: { position: 'top' } }
        },
        dataLabels: {
          enabled: true,
          offsetY: -22,
          style: { fontSize: '12px', colors: [gray700] }
        },
        legend: { show: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            rotate: -35,
            rotateAlways: false,
            hideOverlappingLabels: true,
            trim: true,
            maxHeight: 80,
            style: { colors: gray500, fontSize: '12px' }
          }
        },
        yaxis: {
          labels: { style: { colors: gray500, fontSize: '12px' } }
        },
        fill: { opacity: 1 },
        tooltip: { style: { fontSize: '12px' } },
        colors: [color],
        grid: { borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } }
      }
    },

    // Lookup quantité par nom de catégorie — sales_by_category et
    // sales_count_by_category sont deux listes triées indépendamment (par CA
    // vs par quantité), pas forcément dans le même ordre ni avec les mêmes
    // entrées (le top 10 CA peut différer du top 10 quantité).
    categoryQuantityFor(categoryName) {
      const match = (this.categoryStats.sales_count_by_category || []).find(i => i.category_name === categoryName)
      return match ? match.total_quantity : 0
    },

    drawCategoryComboChart() {
      if (this.categoryComboChart) {
        this.categoryComboChart.destroy()
        this.categoryComboChart = null
      }
      const el = document.querySelector('#category-combo-chart')
      if (!el || !this.categoryStats?.sales_by_category?.length) return

      const categories = this.categoryStats.sales_by_category.map(i => i.category_name)
      const caValues = this.categoryStats.sales_by_category.map(i => parseFloat(i.total_sales).toFixed(2))
      const qtyValues = this.categoryStats.sales_by_category.map(i => this.categoryQuantityFor(i.category_name))

      const borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const gray500 = KTUtil.getCssVariableValue('--bs-gray-500')

      this.categoryComboChart = new ApexCharts(el, {
        series: [
          { name: i18n.global.t('statistics.sale_by_category'), type: 'column', data: caValues },
          { name: i18n.global.t('statistics.quantity_sale'), type: 'line', data: qtyValues },
        ],
        chart: { fontFamily: 'inherit', height: 380, toolbar: { show: false } },
        stroke: { width: [0, 3], curve: 'smooth' },
        plotOptions: { bar: { columnWidth: '40%', borderRadius: 5 } },
        dataLabels: { enabled: false },
        colors: [KTUtil.getCssVariableValue('--bs-info'), KTUtil.getCssVariableValue('--bs-warning')],
        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            rotate: -35,
            rotateAlways: false,
            hideOverlappingLabels: true,
            trim: true,
            maxHeight: 80,
            style: { colors: gray500, fontSize: '12px' }
          }
        },
        yaxis: [
          {
            title: { text: i18n.global.t('statistics.sale_by_category'), style: { fontSize: '11px' } },
            labels: { style: { colors: gray500, fontSize: '12px' } }
          },
          {
            opposite: true,
            title: { text: i18n.global.t('statistics.quantity_sale'), style: { fontSize: '11px' } },
            labels: { style: { colors: gray500, fontSize: '12px' } }
          },
        ],
        legend: { show: true, position: 'top' },
        grid: { borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        tooltip: { style: { fontSize: '12px' } },
      })
      this.categoryComboChart.render()
    },

    drawSalesByProduct() {
      if (this.salesByProduct) {
        this.salesByProduct.destroy()
        this.salesByProduct = null
      }
      const el = document.querySelector('#sales-by-product')
      if (!el || !this.categoryStats?.sales_by_product?.length) return

      const categories = this.categoryStats.sales_by_product.map(i => i.product_name)
      const values = this.categoryStats.sales_by_product.map(i => parseFloat(i.total_sales).toFixed(2))

      this.salesByProduct = new ApexCharts(el, this.buildChartOptions({
        categories, values,
        seriesName: i18n.global.t('statistics.sale_by_product'),
        color: KTUtil.getCssVariableValue('--bs-warning'),
      }))
      this.salesByProduct.render()
    },

    async drawCharts() {
      this.isReady = false
      await this.loadStaticsCount()
      await this.loadCategoryStats()
      this.isReady = true
      await this.$nextTick()
      this.drawSalesByProduct()
      this.drawCategoryComboChart()
    },

    async loadStaticsCount() {
      if (this.shop_selected && this.startDate && this.endDate) {
        await axios.get(`/dashboard/statistics/count?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          .then((response) => {
            this.contacts = response.data.contacts
            this.products = response.data.products
            this.turnover = this.$formatLocalAmount(response.data.turnover)
            this.turnoverTotal = response.data.turnoverTotal
            this.currency = response.data.currency
          })
          .catch(() => {})
      }
    },

    async initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let start = moment().subtract(29, 'days')
      let end = moment()

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [
            i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'),
            i18n.global.t('april'), i18n.global.t('may'), i18n.global.t('june'),
            i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'),
            i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')
          ],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }, this.cb)

      this.cb(start, end)
    },

    catColor(i) {
      const palette = ['#009EF7','#50CD89','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA','#E91E63','#4CAF50']
      return palette[i % palette.length]
    },

    async cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let display = element.querySelector('div')
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY')
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.drawCharts()
      }
    },
  }
}
</script>

<style scoped>
.kpi-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
}

.kpi-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #009EF7, #7239EA);
  border-radius: 12px 12px 0 0;
}

.kpi-icon-box {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-big-number {
  font-size: 1.75rem;
  font-weight: 700;
  color: #181c32;
  line-height: 1.2;
  margin-bottom: 4px;
}

.dashboard-card {
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  border: none;
}

.section-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ─── Liste badge coloré (mobile catégories) ─── */
.cat-badge-list {
  display: flex;
  flex-direction: column;
}

.cat-badge-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.cat-badge-row:last-child { border-bottom: none; }

.cat-badge-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cat-badge-name {
  flex: 1;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e2130;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cat-badge-value {
  font-size: 0.95rem;
  font-weight: 700;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}

.cat-badge-currency {
  font-size: 0.68rem;
  font-weight: 500;
  opacity: 0.7;
  margin-left: 2px;
}

.cat-stat-card {
  background: #f9f9f9;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
}

.cat-stat-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: #5e6278;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cat-stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
}

.cat-stat-currency {
  font-size: 0.7rem;
  font-weight: 500;
  opacity: 0.75;
  margin-left: 2px;
}

</style>
